import { ArrowLeftRight, BanknoteArrowUp, Building2, ChartPie, Landmark, List, ReceiptText } from 'lucide-react';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { SideNavItem } from '../components/side-nav';

export const getNavItemContent = (variant: SideNavItem) => {
  switch (variant) {
    case 'TRANSACTIONS':
      return {
        icon: List,
        label: 'Transactions',
        linkTo: '/dashboard/transactions',
        isBeta: false,
      };
    case 'ACCOUNTS':
      return {
        icon: Landmark,
        label: 'Accounts',
        linkTo: '/dashboard/accounts',
        isBeta: false,
      };
    case 'PAYMENTS':
      return {
        icon: ArrowLeftRight,
        label: 'Payments',
        linkTo: '/dashboard/payments',
        isBeta: false,
      };
    case 'INVOICE_PAY':
      return {
        icon: ReceiptText,
        label: 'Invoice Pay',
        linkTo: '/dashboard/invoice-pay',
        isBeta: false,
      };
    case 'PAYROLLS':
      return {
        icon: BanknoteArrowUp,
        label: 'Payroll',
        linkTo: '/dashboard/payrolls',
        isBeta: true,
      };
    case 'VENDORS':
      return {
        icon: Building2,
        label: 'Vendors',
        linkTo: '/dashboard/vendors',
        isBeta: false,
      };
    case 'REPORTING':
      return {
        icon: ChartPie,
        label: 'Reporting',
        linkTo: '/dashboard/reporting',
        isBeta: false,
      };
    default:
      return exhaustiveCheck(variant);
  }
};
